const React = require('react');
const connect = require('react-redux/dist/react-redux.min.js').connect;
const ReduxStore = require('./redux/reduxStore.jsx.js');
const AjaxFunctions = require('./ajaxFunctions');
const SharedConstants = require('../../../shared/sharedConstants');
const ConfirmationModal = require('./components/confirmationModal.jsx').ConfirmationModal;
const PortfolioList = require('./components/portfolioList.jsx').PortfolioList;

import {
   Button,
   Tab,
   Tabs,
   TextField,
} from '@material-ui/core';
import { FormModal } from './setHeadlines.jsx';


let updatePortfolioList = async () => {
   let portfolioData = await AjaxFunctions.getUserPortfolios();
   ReduxStore.store.dispatch(ReduxStore.PortfolioFunctions.setPortfolioList(portfolioData))
};

let deletePortfolio = async (idPortfolio) => {
   try {
      await AjaxFunctions.deletePortfolio(idPortfolio);
      updatePortfolioList();
   }
   catch(err){
      alert('Error deleting portfolio. Please try again later.')
   }
};

export class PortfolioListPage extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         newPortfolioName: '',
         showDeleteModal: false,
         showCreateModal: false,
         portfolioToDelete: null,
         isDeletingSharedPortfolio: false,
         tab: 0,
      };
   }

   async componentDidMount() {
      await updatePortfolioList();
   }

   async createPortfolio() {
      if(this.state.newPortfolioName.trim() === '') {
         return;
      }
      await AjaxFunctions.createPortfolio(this.state.newPortfolioName);
      await updatePortfolioList();
      this.setState({ newPortfolioName: '', showCreateModal: false });
   }

   handlePortfolioCreationEnter(e) {
      if (e.keyCode === 13) {
         this.createPortfolio();
      }
   }

   beginDeletePortfolio(portfolioToDelete, isDeletingSharedPortfolio) {
      this.setState({portfolioToDelete, showDeleteModal: true, isDeletingSharedPortfolio})
   }

   closeModal() {
      this.setState({portfolioToDelete: null, showDeleteModal: false})
   }

   render() {
      const { 
         tab,
         showCreateModal,
         showDeleteModal,
         isDeletingSharedPortfolio,
         portfolioToDelete
      } = this.state;

      return (
         <div id='portfolioListMainContainer' className={'page-container'}>
            <div className='portfolio-list-page-header'>
               <h1>Create Portfolios</h1>
            </div>
            {window.globals.idUser && 
                  <Button 
                     className='material-button' 
                     variant='outlined' color="primary"
                     onClick={() => this.setState({ showCreateModal: true })}
                  >   
                     Create Portfolio
                  </Button>
            }
            <Tabs 
               className='portfolio-list-page-tab-header'
               value={tab}
               onChange={(event, tab) => this.setState({ tab })}
               indicatorColor="primary"
               textColor="primary"
            >
               <Tab className='portfolio-list-page-tab' label='Your Portfolios' />
               <Tab className='portfolio-list-page-tab' label='Shared Portfolios' />
            </Tabs>
            <br />
            {tab == 0 && 
               <OwnedPortfolioListItems
                  setPortfolioToDelete={idPortfolio => this.beginDeletePortfolio(idPortfolio, false)}
               />
            }
            {tab == 1 && 
               <SharedPortfolioListItems
                  setPortfolioToDelete={idPortfolio => this.beginDeletePortfolio(idPortfolio, true)}
               />
            }
            <ConfirmationModal
               show={showDeleteModal}
               closeFunction={() => this.closeModal()}
               confirmFunction={() => deletePortfolio(portfolioToDelete)}
               contentText={isDeletingSharedPortfolio 
                  ? 'Are you sure you want to leave this portfolio?' 
                  : 'Are you sure you want to delete this portfolio?'
               }
               confirmText={isDeletingSharedPortfolio ? 'Leave' : 'Delete'}
            />
            <FormModal
               show={showCreateModal}
               formHeader='Create A New Portfolio'
               inputs={[
                  <TextField
                     key='portfolio-name'
                     fullWidth
                     id='portfolio-name'
                     label='Portfolio Name'
                     onChange={({ target }) => this.setState({ newPortfolioName: target.value })}
                     style={{ minWidth: 300, width: 500 }}
                  />
               ]}
               confirmText='Create'
               confirmFunction={() => this.createPortfolio()}
               closeFunction={() => this.setState({ showCreateModal: false })}
            />
         </div>
      );
   }
}

const ownedPortfolioListItemsStateToProps = (state) => {
   return {
      portfolioList: state.PortfolioReducer.portfolioList.owned.filter(x => x.privacyType === SharedConstants.PortfolioType.Default),
      isLoaded: state.PortfolioReducer.isLoaded,
   }
};

const sharedPortfolioListItemsStateToProps = (state) => {
   return {
      portfolioList: state.PortfolioReducer.portfolioList.shared.filter(x => x.privacyType === SharedConstants.PortfolioType.Default),
      isLoaded: state.PortfolioReducer.isLoaded,
   }
};

const portfolioListItemsDispatchToProps = (dispatch) => {
   return {
      cardLinkFunction: (cardData) => {
         if(cardData.cardType === SharedConstants.CardType.Evidence)
            dispatch(ReduxStore.EvidenceCardFunctions.setCurrentCard(cardData));
         else if(cardData.cardType === SharedConstants.CardType.Reasoning)
            dispatch(ReduxStore.GreySpaceCardFunctions.setCurrentCard(cardData));

      },
   }
};

const OwnedPortfolioListItems = connect(
   ownedPortfolioListItemsStateToProps,
   portfolioListItemsDispatchToProps
)(PortfolioList);

const SharedPortfolioListItems = connect(
   sharedPortfolioListItemsStateToProps,
   portfolioListItemsDispatchToProps
)(PortfolioList);

